import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sellerPortalCurrency',
})
export class SellerPortalCurrencyPipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): unknown {
    var regex = new RegExp(',', 'g');
    let stringValue = String(value).replace(regex, '');
 //   let decimalValue;
    const isDecimal = stringValue.indexOf('.') > -1;
    let val = stringValue.split('.');
    if (isDecimal) {
      stringValue = val[0];
    }
    if (stringValue.length >= 6) {
      let str =
        stringValue.slice(0, stringValue.length - 5) +
        ',' +
        stringValue.slice(stringValue.length - 5, stringValue.length - 3) +
        ',' +
        stringValue.slice(stringValue.length - 3);
      return isDecimal ? str + '.' + val[1] : str;
    } else if (stringValue.length > 3) {
      let str =
        stringValue.slice(0, stringValue.length - 3) +
        ',' +
        stringValue.slice(stringValue.length - 3);
      return isDecimal ? str + '.' + val[1] : str;
    } else if (stringValue.length <= 3) {
      return String(value).replace(regex, '');
    }
    return value;
  }
}
